import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkCardLink } from 'uitk-react-cards';
import { Link } from 'react-router-dom';
import { onClickScrollToTarget } from 'utils/smooth-scroll';

const LinkTracked = ClickTracker(Link);

export interface AlternateDestinationLinkProps {
  id: string;
  linkName: string;
  position: number;
  searchUrl: string;
}

export class AlternateDestinationLink extends React.Component<AlternateDestinationLinkProps> {
  private handleClick() {
    onClickScrollToTarget({ scrollTo: 0 });
  }

  public render() {
    const { id, linkName, position, searchUrl } = this.props;

    return (
      <UitkCardLink>
        <LinkTracked
          linkName="Click Alternate Destination"
          to={searchUrl}
          rfrr={`.AlternateDestinations.Click${position}.Destination${id}`}
          onClick={this.handleClick}
        >
          {linkName}
        </LinkTracked>
      </UitkCardLink>
    );
  }
}
